import { normalize } from 'normalizr';
import { mergeEntities } from '../modules/entities/actions';

export default function normalizrMiddleware() {
  return ({ dispatch, getState }) => next => (action) => {
    const { schema, module } = action.meta || {};

    if (schema && module && action.payload && !action.error) {
      const normalized = normalize(action.payload, schema);
      const newAction = { ...action, payload: normalized };
      dispatch(mergeEntities(normalized, module));
      return next(newAction);
    }

    return next(action);
  };
}
